import React, { useState, useEffect } from 'react';
import { Smartphone, X, Copy, Check } from 'lucide-react';

const MobileQRButton = () => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [origin, setOrigin] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') setOrigin(window.location.origin);
  }, []);

  const targetUrl = `${origin}/demo?utm_source=qr&utm_medium=web&utm_campaign=demo_mobile`;
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&margin=10&data=${encodeURIComponent(targetUrl)}&bgcolor=ffffff&color=0f172a`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(targetUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-20 right-4 z-40 flex items-center gap-2 px-3.5 py-2.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-full shadow-xl hover:shadow-2xl hover:scale-105 active:scale-95 transition-all group"
        data-testid="qr-demo-btn"
        aria-label="Try demo on your phone"
      >
        <Smartphone className="w-4 h-4" />
        <span className="text-xs font-semibold hidden sm:inline">Scan for Mobile</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="qr-modal"
        >
          <div
            className="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 p-2 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-full transition"
              data-testid="qr-modal-close"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
            <div className="text-center">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-orange-50 text-orange-600 rounded-full text-[10px] font-bold uppercase tracking-widest mb-3">
                <Smartphone className="w-3 h-3" /> Mobile Experience
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-1">Try the Demo on Your Phone</h3>
              <p className="text-xs text-gray-500 mb-4">Scan with your phone's camera — HealthTrack is designed mobile-first.</p>
              <div className="p-3 bg-white border-2 border-gray-100 rounded-2xl inline-block">
                <img src={qrSrc} alt="QR code to demo" width={220} height={220} className="rounded-lg" data-testid="qr-image" />
              </div>
              <div className="mt-4 flex items-center gap-2 p-2 bg-gray-50 rounded-xl">
                <span className="text-[11px] font-mono text-gray-600 truncate flex-1 text-left pl-2">{targetUrl.replace(origin, '…')}</span>
                <button
                  onClick={copy}
                  className="p-1.5 text-gray-500 hover:text-orange-600 hover:bg-white rounded-lg transition"
                  data-testid="qr-copy-btn"
                  title="Copy link"
                >
                  {copied ? <Check className="w-4 h-4 text-emerald-500" /> : <Copy className="w-4 h-4" />}
                </button>
              </div>
              <div className="mt-3 text-[10px] text-gray-400">Campaign tracked via UTM · utm_source=qr</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileQRButton;
